export class DebitNote {
    id: number;
    order_number: string;
    invoice_number: string;
    type: string;
    client: string;
    salesman: string;
    order_date: string;// = (new Date()).toISOString().substr(0,10);
    delivery_date: string;// = (new Date()).toISOString().substr(0,10);
    branch: string;
    branch_code: string;
    branch_name: string;
    branch_id: number;
    //Default to "Draft" status on create
    status: string = 'DRAFT';
    customer_prefix: string;
    customer_name: string;
    customer_id: number;
    customer_po: string;
    notes: string;

    tax: number = 0;
    tax2: number = 0;
  
    items: any[] = [];
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/debit-note.ts